<template>
  <div class="card" :class="cssClass">
    <div class="card-body">
      <div class="lp-auto-loan-calculator">
        <div class="mb-3 mb-lg-4">
          <base-group-input :required-flag="true" inputLabel="Loan Amount" front-group="$">
            <base-input label="Loan Amount"
                        v-model.number="loanAmount"
                        type="number"
                        min="0"
                        placeholder="5000"
                        :show-label="false" />
          </base-group-input>
        </div>
        <div class="mb-3 mb-lg-4">
          <label for="finance-term" class="form-label">
            Finance Term
            <span>*</span>
          </label>
          <select class="form-select"
                  id="finance-term"
                  aria-label="Finance Term"
                  v-model.number="selectedTerm">
            <option v-for="option in termOptions"
                    :key="`finance-term-${option.value}`"
                    :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="mb-3 mb-lg-4">
          <base-group-input :required-flag="true" inputLabel="Interest Rate" back-group="%">
            <base-input label="Interest Rate"
                        v-model.number="interestRate"
                        type="number"
                        min="0"
                        step="0.1"
                        placeholder="5.25"
                        :show-label="false" />
          </base-group-input>
        </div>
        <div class="calculator__total">
          <p>Estimated Monthly Payment</p>
          <div class="calculator-total__number">
            <span>$</span>
            <p>{{ estMonthlyPayment.toLocaleString() }}</p>
          </div>
        </div>
        <hr />
      </div>
      <slot name="cta"></slot>
    </div>
  </div>
  <div class="lp-calculator-disclaimer">
    <slot name="disclaimer"></slot>
  </div>
</template>

<script lang="ts">
  declare const DataIntelligenceSubmitScript: any;
  import { defineComponent, ref, computed, watch } from 'vue';

  import { getAmortizationPayments } from '../helpers/calculators/financial';
  import { debounce } from '../helpers/calculators/input';
  import { sendInsightReport } from '../helpers/calculators/insight';

  import BaseInput from './BaseInput.vue';
  import BaseGroupInput from './BaseGroupInput.vue';

  export default defineComponent({
    name: 'PersonalLoanCalculator',
    components: {
      BaseInput,
      BaseGroupInput,
    },
    props: {
      cssClass: {
        type: String,
        required: false,
        default: '',
      },
    },
    setup() {
      const loanAmount = ref(5000);
      const interestRate = ref(5.25);
      const termOptions = [
        { text: '3 years', value: 3 },
        { text: '4 years', value: 4 },
        { text: '5 years', value: 5 },
        { text: '6 years', value: 6 },
      ];
      const selectedTerm = ref(4);

      const estMonthlyPayment = computed(() => {
        const termInMonths = selectedTerm.value * 12;

        return Math.round(
          getAmortizationPayments(
            loanAmount.value,
            interestRate.value,
            termInMonths,
          ),
        );
      });

      // Sitefinity Insight
      const reportInputToDEC = () => {
        DataIntelligenceSubmitScript._client.sentenceClient.writeSentence({
          predicate: 'Input',
          object: 'Mortgage Calculator',
        });
      };
      watch(
        estMonthlyPayment,
        debounce(() => sendInsightReport(reportInputToDEC)),
      );

      return {
        estMonthlyPayment,
        interestRate,
        loanAmount,
        selectedTerm,
        termOptions,
      };
    },
  });
</script>

<style scoped></style>
